<template>

    <div>
      <el-row>
        <el-col :span="24">
          <transition v-if="actionData" name="el-zoom-in-center">

            <section v-if="requestType === 'rta'" :class="requestType + '-bg-colour'">
              <site-details :row-data="actionData" />
            </section>

            <section v-else>

              <div v-if="isActive(actionData)" :class="requestType + '-bg-colour'">
                <request-workflow class="padded" :row-data="actionData" :row-index="rowIndex" :close-dialog="closeDialog" />

              <hr />

            </div>
            <div v-else>

              <completed-request :row-data="actionData" :row-index="rowIndex" />

            </div>

          </section>

          </transition>
        </el-col>

      </el-row>
    </div>

</template>


<script>

import RequestMixins from '@/mixins/RequestMixins'

import RequestSearch from '@/components/requests/RequestSearch'

import SiteDetails from '@/components/tables/details/SiteDetails'
import CompletedRequest from '@/components/requests/workflow/CompletedRequest'
import RequestWorkflow from '@/components/requests/workflow/RequestWorkflow'


export default {
  mixins: [RequestMixins],

  components: {
    CompletedRequest,
    SiteDetails,
    RequestSearch,
    RequestWorkflow
  },

  props: {

    rowData: {
      type: Object,
      default: null
    },

    rowIndex: {
      type: Number
    },

    closeDialog: {
      type: Function,
      default: null
    },

    // When true and rowData is already fully-hydrated (e.g. by RequestDetailLayer),
    // skip the /actions/{id} re-fetch in created() and use rowData directly.
    // The /site/{id} fetch for the RTA branch is unaffected.
    skipInitialFetch: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    initTelco (data) {

        if (this.actionData.organisation_id) {

          this.updateEmailList(this.actionData.emails.telco,
            data,
            this.actionData.emails.addMissing)
          }

       if (this.canWriteStep()) {
         this.saveRequest(this.actionData)
       }
    },


    initRequest (data) {

      this.actionData = data

      if (this.actionData && this.actionData.emails) {

        if (this.actionData.emails.tower.length === 0) {

          if (this.xolasClient().contacts) {

            this.updateEmailList(this.actionData.emails.tower,
              this.xolasClient().contacts,
              this.actionData.emails.addMissing)
            }

          } // if tower.length === 0


          if (this.actionData.emails.telco.length === 0) {
            this.fetchData('/contacts/org/' + this.actionData.organisation_id + '/raw', this.initTelco, 'Contacts')
          } // if telco.length === 0


        } // if actionData...


    }  // initRequest

  },   // methods



  data () {
    return {
      actionData: null,
      requestType: (this.rowData.actionType ? this.rowData.actionType.toLowerCase() : 'rts')
    }

  },


  beforeDestroy () {

    if (this.requestType !== 'rta') {
       let ev = this.requestTableRef(this.actionData.actionType) + '-refresh-table'
       this.$events.emit(ev)
    }

  },



  created () {
    if (this.requestType !== 'rta') {
      if (this.skipInitialFetch) {
        // rowData is already hydrated by the caller (e.g. RequestDetailLayer).
        // Call initRequest directly to run the email-list initialisation without
        // a second round-trip to /actions/{id}.
        this.initRequest(this.rowData)
      } else {
        this.fetchData('/actions/' + this.rowData.id, this.initRequest)
      }
    } else {
      this.fetchData('/site/' + this.rowData.site_id, this.initRequest)
    }

  }

}

</script>

<style scoped>
.el-select {display: inline-block; width: 100%;}
.rta-bg-colour {background-color: #FDF6EC;};
.rts-bg-colour {background-color: #F0F9EC;};
.rtu-bg-colour {background-color: #EDF5FF;};
.rtb-bg-colour {background-color: #F4F4F5;};
.rtd-bg-colour {background-color: #FEF0F0;};

</style>
